import { create } from "zustand";

export interface MessageBanner {
  id: string;
  type: "error" | "warning" | "success" | "informational";
  message: string;
}

interface NotificationStore {
  banners: MessageBanner[];
  addBanner: (banner: Omit<MessageBanner, "id">) => void;
  removeBanner: (id: string) => void;
  clearBanners: () => void;
}

export const initialNotificationState: Pick<NotificationStore, "banners"> = { banners: [] };

export const useNotificationStore = create<NotificationStore>((set) => ({
  banners: [],
  addBanner: (banner) =>
    set((state) => ({
      banners: [...state.banners, { ...banner, id: `banner-${Date.now()}-${Math.random().toString(36).substr(2, 9)}` }],
    })),
  removeBanner: (id) =>
    set((state) => ({ banners: state.banners.filter((b) => b.id !== id) })),
  clearBanners: () => set({ banners: [] }),
}));
